<dashboardnav>
  
    <cradua-pipeline-license-category
    [pipelinelicensecategorys]="pipelinelicensecategorys$ | async"
    (pipelinelicensecategory)="onSubmitPipelineLicenseCategory($event)"
    (deletePipelineLicenseCategoryEvent)="onDeletePipelineLicenseCategory($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-pipeline-license-category>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  